export default "__VITE_ASSET__DfbxE3bm__"